import { render } from "./SearchIcon01.vue?vue&type=template&id=4dfc462f&scoped=true"
import script from "./SearchIcon01.vue?vue&type=script&lang=js"
export * from "./SearchIcon01.vue?vue&type=script&lang=js"

import "./SearchIcon01.vue?vue&type=style&index=0&id=4dfc462f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfc462f"]])

export default __exports__